var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_156_5716",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_156_5716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.6L14.65 11.65L10.7 9.8L14.65 7.95L16.5 4L18.35 7.95L22.3 9.8L18.35 11.65L16.5 15.6ZM30 21.65L28.45 18.35L25.15 16.8L28.45 15.25L30 11.95L31.55 15.25L34.85 16.8L31.55 18.35L30 21.65ZM6.85 25.65L5.3 22.35L2 20.8L5.3 19.25L6.85 15.95L8.4 19.25L11.7 20.8L8.4 22.35L6.85 25.65ZM8.3 41L6 38.7L21 23.7L29 31.75L43.9 15.05L46 17.1L29 36.25L21 28.3L8.3 41Z",
    fill: "#0BAB47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoGraph);
export default __webpack_public_path__ + "static/media/auto_graph.e02a0980b33ab52d1261e35ec4d8b3cf.svg";
export { ForwardRef as ReactComponent };